import { PAGE_ROUTES } from '@/components/nav/utils/url-builders';
import { isPageActive } from '@/lib/is-page-active';
import {
  hydrateCustomers,
  hydrateDeals,
  hydrateUsers,
  hydrateVehiclesAndListingsFromIndexer,
} from '@/models/hydrate';
import { runInAction } from 'mobx';
import { useEffect } from 'react';

const useContractQueuePageHydrateLatest = () => {
  const isContractQueuePageActive = isPageActive(PAGE_ROUTES.CONTRACT_QUEUE);
  const shouldRun = isContractQueuePageActive;

  useEffect(() => {
    if (!shouldRun) {
      return;
    }

    const hydrateContractQueuePage = async () => {
      // Fetch latest data from API for contract queue page
      // This ensures eventual consistency with the server
      await Promise.all([
        hydrateDeals(),
        hydrateCustomers(),
        hydrateVehiclesAndListingsFromIndexer(),
        hydrateUsers(),
      ]);
    };

    runInAction(async () => {
      await hydrateContractQueuePage();
    });
  }, [shouldRun]);
};

export default useContractQueuePageHydrateLatest;
